module.exports = __webpack_public_path__ + "static/media/Shabnam-Bold.1cf3a131.woff2";